import React, { useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";
import { ChevronDown, Settings2 } from "lucide-react";

const NUM = [["referrer_bonus", "Bonus a chi invita (€)"], ["invitee_bonus", "Bonus al nuovo dealer (€)"], ["suspend_days", "Sospensione dopo (giorni)"], ["penalty_days", "Penale sul credito dopo (giorni)"], ["notice_days", "Preavviso via email (giorni)"]];

export function EngagementSettings({ initial, onSaved }) {
  const [open, setOpen] = useState(false);
  const [f, setF] = useState({ ...initial, reminder_days: (initial.reminder_days || []).join(", "), reason: "" });
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try {
      await api.put("/admin/dealer-engagement/settings", { ...f, ...Object.fromEntries(NUM.map(([k]) => [k, Number(f[k])])), reminder_days: String(f.reminder_days).split(/[\s,;]+/).filter(Boolean).map(Number) });
      toast.success("Regole salvate"); onSaved();
    } catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail) || "Errore salvataggio"); }
    finally { setBusy(false); }
  };
  return (
    <Card className="p-4 glow-border" data-testid="engagement-settings">
      <button type="button" className="w-full flex items-center justify-between gap-2 text-left" onClick={() => setOpen((o) => !o)} data-testid="engagement-settings-toggle">
        <span className="font-head font-semibold flex items-center gap-2"><Settings2 className="w-4 h-4 text-primary" /> Regole inviti e inattività</span>
        <span className="text-xs text-muted-foreground flex items-center gap-1">Inviti all'utilizzo dopo {(initial.reminder_days || []).join(", ")} giorni · sospensione a {initial.suspend_days} · penale a {initial.penalty_days}<ChevronDown className={`w-4 h-4 transition-transform ${open ? "rotate-180" : ""}`} /></span>
      </button>
      {open && <div className="mt-4 space-y-3">
        <label className="flex items-center gap-2 text-sm"><Switch checked={!!f.referral_enabled} onCheckedChange={(v) => setF({ ...f, referral_enabled: v })} data-testid="engagement-referral-enabled" /> Programma «Presenta un dealer» attivo</label>
        <div className="grid sm:grid-cols-3 gap-3">
          {NUM.map(([k, l]) => <div key={k}><Label className="text-xs">{l}</Label><Input type="number" className="mt-1" value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={`engagement-${k}`} /></div>)}
          <div><Label className="text-xs">Inviti all'utilizzo dopo (giorni)</Label><Input className="mt-1" value={f.reminder_days} onChange={(e) => setF({ ...f, reminder_days: e.target.value })} data-testid="engagement-reminder_days" /></div>
        </div>
        <p className="text-xs text-amber-500" data-testid="engagement-contract-note">Importi e scadenze sono scritti anche nel contratto: se li cambi, pubblica una nuova versione in «Contratto & Dati piattaforma».</p>
        <div className="flex flex-wrap items-end gap-3 justify-end">
          <Input className="max-w-sm" placeholder="Motivo della modifica" value={f.reason} onChange={(e) => setF({ ...f, reason: e.target.value })} data-testid="engagement-reason" />
          <Button disabled={busy || f.reason.trim().length < 3} className="bg-emerald-600 hover:bg-emerald-700 text-white" onClick={save} data-testid="engagement-save">Salva regole</Button>
        </div>
      </div>}
    </Card>
  );
}
